import { PaginasOutrosRegimes } from 'interfaces/IBasesCalculo';

export enum EBaseCalculo {
  BALNEARIO_COM_BANHO = 'balnearioComBanho',
  BALNEARIO_SEM_BANHO = 'balnearioSemBanho',
  RECEITA_CALCULADA_EXPORTACOES = 'receitaExportacoes',
  RECEITA_BRUTA_CALCULADA = 'receitaBrutaCalculada',
  RECEITA_BRUTA_VENDAS = 'receitaBruta',
  VENDA_NACIONAL = 'vendaNacional',
}

interface EBaseCalculoInfo {
  nome: string;
  indice: number;
  label: string;
}

export const EBaseCalculoDetalhe: { [key in EBaseCalculo]: EBaseCalculoInfo } = {
  [EBaseCalculo.BALNEARIO_COM_BANHO]: {
    nome: 'BALNEARIO_COM_BANHO',
    indice: 0,
    label: 'Balneário com Banho',
  },
  [EBaseCalculo.BALNEARIO_SEM_BANHO]: {
    nome: 'BALNEARIO_SEM_BANHO',
    indice: 1,
    label: 'Balneário sem Banho',
  },
  [EBaseCalculo.RECEITA_CALCULADA_EXPORTACOES]: {
    nome: 'RECEITA_CALCULADA_EXPORTACOES',
    indice: 2,
    label: 'Receita Calculada Exportações',
  },
  [EBaseCalculo.RECEITA_BRUTA_CALCULADA]: {
    nome: 'RECEITA_BRUTA_CALCULADA',
    indice: 3,
    label: 'Receita Bruta Calculada',
  },
  [EBaseCalculo.RECEITA_BRUTA_VENDAS]: {
    nome: 'RECEITA_BRUTA_VENDAS',
    indice: 4,
    label: 'Receita Bruta de Vendas',
  },
  [EBaseCalculo.VENDA_NACIONAL]: {
    nome: 'VENDA_NACIONAL',
    indice: 5,
    label: 'Venda Nacional',
  },
};

export const getNomeEBaseCalculoByValue = (value: string): EBaseCalculo => {
  return (Object.values(EBaseCalculo) as string[]).find((baseCalculo) => baseCalculo === value) as EBaseCalculo;
};

export const getReceitaLabel = (nomeBaseCalculo: PaginasOutrosRegimes) => {
  switch (nomeBaseCalculo) {
    case 'receitaBruta':
      return 'Receita Bruta de Vendas (R$)';
    case 'vendaNacional':
      return 'Receita Bruta de Vendas (R$)';
    case 'receitaExportacoes':
      return 'Receita Calculada (R$)';
    case 'receitaBrutaCalculada':
      return 'Receita Bruta Calculada (R$)';
    default:
      return 'Receita Bruta';
  }
};
